import { render, staticRenderFns } from "./Sella-back.vue?vue&type=template&id=48313e9c"
import script from "./Sella-back.vue?vue&type=script&lang=js"
export * from "./Sella-back.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports